import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      addPath: null,
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
    },
    debug: process.env.NODE_ENV === 'development',
    lng: 'de',
    fallbackLng: 'de',
    returnNull: false,
    returnEmptyString: true,
    interpolation: {
      escapeValue: false
    },
    keySeparator: false,
    nsSeparator: false,
    saveMissing: false,
    ns: ['mc'],
    defaultNS: 'mc'
  });

export { i18n };
